import { render, staticRenderFns } from "./SkupSuorganizatorForma.vue?vue&type=template&id=6b483e64&scoped=true&"
import script from "./SkupSuorganizatorForma.vue?vue&type=script&lang=js&"
export * from "./SkupSuorganizatorForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b483e64",
  null
  
)

export default component.exports